const Notification = ({ message }) => {
  return <p>{message}</p>;
};

export default Notification;
